import React from 'react';
import { FormControl,FormLabel, KeyboardDatePicker, MuiPickersUtilsProvider, DateFnsUtils } from '../../../../third-party-components/material-ui';
import { DatePicker } from '../../../../third-party-components/kendo-react-ui';
import {
    IntlProvider,
    load,
    loadMessages,
    LocalizationProvider,
} from "@progress/kendo-react-intl";

import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import currencyData from "cldr-core/supplemental/currencyData.json";
import weekData from "cldr-core/supplemental/weekData.json";

import esNumbers from "cldr-numbers-full/main/es-US/numbers.json";
import esCaGregorian from "cldr-dates-full/main/es-US/ca-gregorian.json";
import esDateFields from "cldr-dates-full/main/es-US/dateFields.json";
import esTimeZoneNames from "cldr-dates-full/main/es-US/timeZoneNames.json";
import esMessages from "../../../../assets/lang/es.json";

import frNumbers from "cldr-numbers-full/main/fr/numbers.json";
import frCaGregorian from "cldr-dates-full/main/fr/ca-gregorian.json";
import frDateFields from "cldr-dates-full/main/fr/dateFields.json";
import frTimeZoneNames from "cldr-dates-full/main/fr/timeZoneNames.json";
import frMessages from "../../../../assets/lang/fr.json";

import { config } from '../../../../Constants';

load(
  likelySubtags,
  currencyData,
  weekData,
  esNumbers,
  esCaGregorian,
  esDateFields,
  esTimeZoneNames,
  frNumbers,
  frCaGregorian,
  frDateFields,
  frTimeZoneNames
);
loadMessages(esMessages, "es-US");
loadMessages(frMessages, "fr");

class DemoQuestionDatePicker extends React.Component {
    constructor(props){
        super(props)
        this.state = {locale: "en-US"};
    }

    componentDidMount(){
        this.setState({locale: this.props.lang === undefined ? "en-US" : this.props.lang})
    }   

    render() {
        const {name, lang, label, className, value, format, validationMessage = '', required, disableFuture, onChange, formatPlaceholder} = this.props;
        let dateFormat = 'MM/dd/yyyy';
        let selectedDate = null;

        if (format) {
            dateFormat = format;
        }

        if (value !== undefined && value !== '') {
            selectedDate = new Date(value);
        }

        var min = new Date('1900/1/1');
        var max = new Date();

        if (config.datePickerMin) {
            console.log(config.datePickerMin);
            try {
                min = new Date(Date.parse(config.datePickerMin));
                console.log(min);
            } catch {
                
            }
        }

        if (config.datePickerMax) {
            try {
                max = new Date(Date.parse(config.datePickerMax));
            } catch {

            }
        }

        return (
            <React.Fragment>
                <FormControl className={`demo-control demo-text ${className}`} component="fieldset" onKeyDown={() => {return false}}>
                    <FormLabel className="demo-label" component="legend">{label}{required && <span className="label-required">*</span>}</FormLabel>
                    <FormLabel className={"demo-error" + (validationMessage != '' ? ' margin' : '')} component="legend">{validationMessage}</FormLabel>
                    <LocalizationProvider language={this.state.locale}>
                        <IntlProvider locale={this.state.locale}>
                            <DatePicker
                                min={min}
                                max={max}
                                className="demo-datepicker"
                                name={name}
                                value={selectedDate} 
                                format={dateFormat}
                                onChange={onChange}
                                formatPlaceholder={formatPlaceholder}
                            />
                        </IntlProvider>
                    </LocalizationProvider>
                </FormControl>
            </React.Fragment>
        )
    }
}

export default DemoQuestionDatePicker;